import {TypeUtils} from "../../shared/utils/type-utils";
import {
  FINISH_ONGOING_ACTIVITIES_SESSION,
  FINISH_ONGOING_ACTIVITY,
  INIT_ONGOING_ACTIVITIES,
  OngoingActivitiesAction,
  UPDATE_ONGOING_ACTIVITY_STATE,
  UpdateOngoingActivityState
} from "../actions/ongoing-activities.action";
import {IActivity} from "../../activities/activity";
import {
  FinishOngoingActivity,
  REMOVE_ONGOING_ACTIVITY,
  RemoveOngoingActivity,
  TOGGLE_ONGOING_ACTIVITIES,
  ToggleOngoingActivities
} from "../actions";
import {Utils} from '../../shared/utils/utils';

export interface IWebsiteOngoingActivitiesState {
  websiteId: number;
  entities: {[activityId: string]: IActivity};
}

export interface IOngoingActivitiesState {
  entities: {[websiteId: number]: IWebsiteOngoingActivitiesState};
  inited: boolean;
  toggled: boolean;
}

export const initialState: IOngoingActivitiesState = {
  entities: {},
  inited: false,
  toggled: false
};

export function reducer(state: IOngoingActivitiesState = initialState, action: OngoingActivitiesAction): IOngoingActivitiesState {
  let payload: any;

  switch (action.type) {

    case INIT_ONGOING_ACTIVITIES:
      payload = action.payload;

      return {
        ...state,
        entities: payload,
        inited: true
      };

    case UPDATE_ONGOING_ACTIVITY_STATE:
      payload = (<UpdateOngoingActivityState>action).payload;
      const entities = state.entities[payload.websiteId]
        ? {
          ...state.entities[payload.websiteId].entities,
          [payload.entity.id]: payload.entity
        }
        : {
          [payload.entity.id]: payload.entity
        };

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: entities
          }
        }
      };

    case FINISH_ONGOING_ACTIVITY:
      payload = (<FinishOngoingActivity>action).payload;
      const websiteActivities: {[activityId: string]: IActivity} = state.entities[payload.websiteId] && state.entities[payload.websiteId].entities ? state.entities[payload.websiteId].entities : {};

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: {
              ...websiteActivities,
              [payload.entity.id]: {
                ...websiteActivities[payload.entity.id],
                finished: true
              }
            }
          }
        }
      };

    case FINISH_ONGOING_ACTIVITIES_SESSION:
      return {
        ...state,
        entities: Object.keys(state.entities).reduce((websiteStateEntities: any, websiteId: string) => {
          const websiteState: IWebsiteOngoingActivitiesState = state.entities[websiteId];

          websiteStateEntities[websiteId] = {
            ...websiteState,
            entities: Utils.arrayToEntities(Object.values(websiteState.entities).filter((activity: IActivity) => {
              return !activity.finished;
            }), 'id')
          };

          return websiteStateEntities;
        }, {})
      };

    case REMOVE_ONGOING_ACTIVITY:
      payload = (<RemoveOngoingActivity>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: state.entities[payload.websiteId] ? Utils.removeEntityByKey(state.entities[payload.websiteId].entities, payload.activityId) : []
          }
        }
      };

    case TOGGLE_ONGOING_ACTIVITIES:
      let toggled: boolean = (<ToggleOngoingActivities>action).payload;
      if (TypeUtils.isUndefined(toggled)) {
        toggled = !state.toggled;
      }

      return {
        ...state,
        toggled: toggled
      };

  }

  return state;
}
